"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadedDayOverview = exports.startedRefreshingDayOverview = exports.startedLoadingDayOverview = exports.loadedDashboard = exports.startedRefreshingDashboard = exports.startedLoadingDashboard = exports.clearedDashboard = void 0;
const initial_1 = __importDefault(require("@app/store/initial"));
const toolkit_1 = require("@reduxjs/toolkit");
const dashboardSlice = (0, toolkit_1.createSlice)({
    name: 'dashboard',
    initialState: initial_1.default.dashboard,
    reducers: {
        // Dispatched when the page mounts. Both keys go back to null, so the page's own
        // `key !== key` comparison refetches the metrics and the rows even where the cached
        // payload is for the very same workspace, day and filters — opening the dashboard is a
        // request for what is happening now, not for what it looked like on the last visit.
        // Clearing the data with them keeps the honest state on screen: a skeleton while the
        // numbers are in flight, never a stale figure that looks live. `isLoading` is reset too,
        // because a request still in flight from the previous visit is dropped by the key guard
        // below and would otherwise leave the flag stuck on.
        clearedDashboard: (state) => {
            state.key = null;
            state.data = null;
            state.isLoading = false;
            state.hasError = false;
            state.dayOverview.key = null;
            state.dayOverview.data = null;
            state.dayOverview.toleranceMinutes = null;
            state.dayOverview.isLoading = false;
            state.dayOverview.hasError = false;
        },
        // Dropping `data` here is deliberate: while another workspace's numbers are in flight
        // the honest thing to show is a skeleton, not the previous workspace's figures under
        // this workspace's name.
        startedLoadingDashboard: (state, action) => {
            state.key = action.payload;
            state.data = null;
            state.isLoading = true;
            state.hasError = false;
        },
        // The periodic refetch of what is already on screen: unlike the start above it keeps the
        // figures (and the error card, if any) up until the answer lands, so the four sections do
        // not drop back to skeletons every few minutes.
        startedRefreshingDashboard: (state, action) => {
            state.key = action.payload;
        },
        // A failed load lands here with `hasError`, so the page can say so inline instead of
        // leaving four em dashes behind — which is what a metric the manager may not see renders
        // as, and what a workspace with nothing scheduled renders as too.
        loadedDashboard: (state, action) => {
            // Two quick workspace switches can resolve out of order; a response for a key we have
            // already moved off must not overwrite the current one.
            if (state.key !== action.payload.key)
                return;
            // A background refetch that failed keeps the live figures rather than swapping them for
            // an error card the manager never asked for; `processErrors` already toasted why.
            if (action.payload.isRefresh === true && action.payload.hasError)
                return;
            state.data = action.payload.data;
            state.hasError = action.payload.hasError;
            state.isLoading = false;
        },
        // Same two-step and the same key guard as the metrics above, but a separate entry: the
        // two widgets are fetched by separate operations so that filtering one leaves the other
        // on screen instead of dropping it back to a skeleton.
        startedLoadingDayOverview: (state, action) => {
            state.dayOverview.key = action.payload;
            state.dayOverview.data = null;
            state.dayOverview.toleranceMinutes = null;
            state.dayOverview.isLoading = true;
            state.dayOverview.hasError = false;
        },
        // Same as `startedRefreshingDashboard`: the rows stay on screen until the answer lands.
        startedRefreshingDayOverview: (state, action) => {
            state.dayOverview.key = action.payload;
        },
        loadedDayOverview: (state, action) => {
            if (state.dayOverview.key !== action.payload.key)
                return;
            if (action.payload.isRefresh === true && action.payload.hasError)
                return;
            state.dayOverview.data = action.payload.data;
            state.dayOverview.toleranceMinutes = action.payload.toleranceMinutes;
            state.dayOverview.hasError = action.payload.hasError;
            state.dayOverview.isLoading = false;
        },
    },
});
_a = dashboardSlice.actions, exports.clearedDashboard = _a.clearedDashboard, exports.startedLoadingDashboard = _a.startedLoadingDashboard, exports.startedRefreshingDashboard = _a.startedRefreshingDashboard, exports.loadedDashboard = _a.loadedDashboard, exports.startedLoadingDayOverview = _a.startedLoadingDayOverview, exports.startedRefreshingDayOverview = _a.startedRefreshingDayOverview, exports.loadedDayOverview = _a.loadedDayOverview;
exports.default = dashboardSlice.reducer;
